<template>
    <div class="activity-preview-container">
        <div class="activity-preview-card">
            <h2>Paušalko</h2>
            <div v-if="loading" class="activity-preview-message">
                {{ $LANG.Get('labels.loading') }}
            </div>
            <div v-if="!loading && !valid" class="activity-preview-error">
                {{ $LANG.Get('labels.activityPreviewInvalid') }}
            </div>
            <div v-if="!loading && valid && !sent">
                <p>{{ $LANG.Get('labels.activityPreviewEnterEmail') }}</p>
                <NevsTextField v-model="email" :error="emailError"
                               :label="$LANG.Get('fields.email')"></NevsTextField>
                <div class="activity-preview-buttons">
                    <NevsButton class="success" @click="sendClick">
                        <i class="fa-solid fa-paper-plane"></i>
                        {{ $LANG.Get('buttons.send') }}
                    </NevsButton>
                </div>
                <div v-if="mismatchError" class="activity-preview-error">
                    {{ $LANG.Get('labels.activityPreviewEmailMismatch') }}
                </div>
            </div>
            <div v-if="!loading && valid && sent" class="activity-preview-success">
                {{ $LANG.Get('labels.activityPreviewEmailSent') }}
            </div>
        </div>
    </div>
</template>

<script>
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import axios from "axios";
import Settings from "@/config.json";

export default {
    name: "ActivityPreview",
    components: {NevsButton, NevsTextField},
    data() {
        return {
            loading: true,
            valid: false,
            email: '',
            emailError: '',
            mismatchError: false,
            sent: false,
            clientHash: this.$route.params.client_hash,
            accessHash: this.$route.params.access_hash
        }
    },
    methods: {
        sendClick() {
            this.mismatchError = false;

            if (this.email === '' || this.email === null) {
                this.emailError = this.$LANG.Get('labels.mandatoryField');
                return;
            }
            if (!this.$HELPERS.CheckEmail(this.email)) {
                this.emailError = this.$LANG.Get('labels.invalidEmailAddress');
                return;
            }
            this.emailError = '';

            let vm = this;
            axios({
                method: 'post',
                url: Settings.API_BASE + 'activity-preview/send-email/' + this.clientHash + '/' + this.accessHash,
                data: {email: this.email}
            }).then(function (response) {
                if (response.data.success) {
                    vm.sent = true;
                } else if (response.data.error === 'email_mismatch') {
                    vm.mismatchError = true;
                }
            }).catch(function () {
                vm.mismatchError = true;
            });
        }
    },
    mounted() {
        let vm = this;
        axios({
            method: 'get',
            url: Settings.API_BASE + 'activity-preview/validate/' + this.clientHash + '/' + this.accessHash
        }).then(function (response) {
            vm.valid = response.data.valid;
            vm.loading = false;
        }).catch(function () {
            vm.valid = false;
            vm.loading = false;
        });
    }
}
</script>

<style scoped>
.activity-preview-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: #f0f4f8;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.activity-preview-card {
    background: white;
    border-radius: 10px;
    padding: 40px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
    max-width: 450px;
    width: 100%;
}

.activity-preview-card h2 {
    margin: 0 0 20px;
    text-align: center;
    color: #333;
}

.activity-preview-error {
    color: #d9534f;
    text-align: center;
    padding: 10px;
}

.activity-preview-success {
    color: #5cb85c;
    text-align: center;
    padding: 10px;
    font-size: 16px;
}

.activity-preview-message {
    text-align: center;
    padding: 10px;
    color: #666;
}

.activity-preview-buttons {
    margin-top: 15px;
    text-align: center;
}
</style>
